import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class CouldNotRetrieveLicenseLinkedRegistrationException extends LicenseException
{

}
